import React from 'react';

const Logo = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-2 md:gap-3 ${className}`}>
      {/* Logo Icon - 5 Propane-Style Gas Tanks Power Rangers Formation */}
      <div className="relative flex-shrink-0">
        <svg 
          width="64" 
          height="48" 
          viewBox="0 0 64 48" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="w-14 h-12 md:w-16 md:h-14"
        >
          {/* Background badge */}
          <rect x="1" y="1" width="62" height="46" rx="6" fill="#f8fafc" stroke="#e2e8f0" strokeWidth="1.5"/>
          
          {/* The Freon Rangers - Centered and Properly Proportioned */}
          
          {/* R22 - GREEN TANK (Far Left) */}
          <g transform="translate(7, 0)">
            {/* Valve on top */}
            <rect x="2.5" y="11" width="1.5" height="1.5" rx="0.3" fill="#047857"/>
            <circle cx="3.25" cy="10.5" r="0.6" fill="#34d399"/>
            {/* Rounded dome top - proper proportion */}
            <ellipse cx="3.25" cy="12.5" rx="3" ry="2" fill="#10b981" stroke="#1f2937" strokeWidth="0.4"/>
            <ellipse cx="3.25" cy="12.5" rx="2.5" ry="1.5" fill="#34d399" opacity="0.5"/>
            {/* Main tank body - proportional to dome */}
            <rect x="0.5" y="13" width="5.5" height="16" rx="2.5" fill="#10b981" stroke="#1f2937" strokeWidth="0.4"/>
            {/* Shine highlight */}
            <rect x="1.5" y="15" width="1" height="12" rx="0.5" fill="white" opacity="0.35"/>
            {/* Label band */}
            <rect x="0.5" y="20" width="5.5" height="3" fill="#047857" rx="0.3"/>
            <text x="3.25" y="22.5" fontSize="2" fill="white" textAnchor="middle" fontWeight="bold">R22</text>
            {/* Bottom base/stand */}
            <rect x="0.5" y="29" width="5.5" height="2" rx="1" fill="#047857"/>
            <ellipse cx="3.25" cy="31" rx="3.2" ry="1" fill="#059669"/>
          </g>
          
          {/* R410A - PINK TANK (Center Left) */}
          <g transform="translate(14, 0)">
            {/* Valve on top */}
            <rect x="3" y="9" width="1.8" height="1.8" rx="0.4" fill="#be185d"/>
            <circle cx="3.9" cy="8.5" r="0.7" fill="#f472b6"/>
            {/* Rounded dome top */}
            <ellipse cx="3.9" cy="10.8" rx="3.5" ry="2.5" fill="#ec4899" stroke="#1f2937" strokeWidth="0.4"/>
            <ellipse cx="3.9" cy="10.8" rx="3" ry="2" fill="#f472b6" opacity="0.5"/>
            {/* Main tank body */}
            <rect x="0.5" y="11.5" width="6.8" height="19" rx="3" fill="#ec4899" stroke="#1f2937" strokeWidth="0.4"/>
            {/* Shine highlight */}
            <rect x="1.5" y="13.5" width="1.3" height="15" rx="0.6" fill="white" opacity="0.4"/>
            {/* Label band */}
            <rect x="0.5" y="19" width="6.8" height="4" fill="#be185d" rx="0.3"/>
            <text x="3.9" y="22" fontSize="2.5" fill="white" textAnchor="middle" fontWeight="bold">410A</text>
            {/* Bottom base/stand */}
            <rect x="0.5" y="30.5" width="6.8" height="2.5" rx="1.2" fill="#be185d"/>
            <ellipse cx="3.9" cy="33" rx="3.8" ry="1.2" fill="#db2777"/>
          </g>
          
          {/* R454B - WHITE/SILVER TANK (CENTER - Leader/Largest) */}
          <g transform="translate(24, 0)">
            {/* Valve on top */}
            <rect x="4" y="7" width="2.2" height="2" rx="0.5" fill="#6b7280"/>
            <circle cx="5.1" cy="6.5" r="0.8" fill="#d1d5db"/>
            {/* Rounded dome top - larger for leader */}
            <ellipse cx="5.1" cy="9" rx="4.5" ry="3" fill="#e5e7eb" stroke="#1f2937" strokeWidth="0.5"/>
            <ellipse cx="5.1" cy="9" rx="3.8" ry="2.5" fill="#f9fafb" opacity="0.7"/>
            {/* Main tank body - largest and most prominent */}
            <rect x="0.5" y="10" width="9.2" height="23" rx="4" fill="#e5e7eb" stroke="#1f2937" strokeWidth="0.5"/>
            {/* Strong shine highlights */}
            <rect x="1.5" y="12" width="1.8" height="19" rx="0.8" fill="white" opacity="0.55"/>
            <rect x="7" y="12" width="1" height="19" rx="0.4" fill="#9ca3af" opacity="0.15"/>
            {/* Blue label band */}
            <rect x="0.5" y="18" width="9.2" height="5" fill="#3b82f6" rx="0.4"/>
            <text x="5.1" y="21.5" fontSize="3.2" fill="white" textAnchor="middle" fontWeight="bold">454B</text>
            {/* Warning stripe */}
            <rect x="0.5" y="27" width="9.2" height="2" fill="#fbbf24" rx="0.3"/>
            {/* Bottom base/stand */}
            <rect x="0.5" y="33" width="9.2" height="3" rx="1.5" fill="#9ca3af"/>
            <ellipse cx="5.1" cy="36" rx="5" ry="1.5" fill="#d1d5db"/>
          </g>
          
          {/* R134A - BLUE TANK (Center Right) */}
          <g transform="translate(36, 0)">
            {/* Valve on top */}
            <rect x="3" y="9" width="1.8" height="1.8" rx="0.4" fill="#1e40af"/>
            <circle cx="3.9" cy="8.5" r="0.7" fill="#60a5fa"/>
            {/* Rounded dome top */}
            <ellipse cx="3.9" cy="10.8" rx="3.5" ry="2.5" fill="#3b82f6" stroke="#1f2937" strokeWidth="0.4"/>
            <ellipse cx="3.9" cy="10.8" rx="3" ry="2" fill="#60a5fa" opacity="0.5"/>
            {/* Main tank body */}
            <rect x="0.5" y="11.5" width="6.8" height="19" rx="3" fill="#3b82f6" stroke="#1f2937" strokeWidth="0.4"/>
            {/* Shine highlight */}
            <rect x="1.5" y="13.5" width="1.3" height="15" rx="0.6" fill="white" opacity="0.4"/>
            {/* Label band */}
            <rect x="0.5" y="19" width="6.8" height="4" fill="#1e40af" rx="0.3"/>
            <text x="3.9" y="22" fontSize="2.5" fill="white" textAnchor="middle" fontWeight="bold">134A</text>
            {/* Bottom base/stand */}
            <rect x="0.5" y="30.5" width="6.8" height="2.5" rx="1.2" fill="#1e40af"/>
            <ellipse cx="3.9" cy="33" rx="3.8" ry="1.2" fill="#2563eb"/>
          </g>
          
          {/* 404A - ORANGE TANK (Far Right) */}
          <g transform="translate(46, 0)">
            {/* Valve on top */}
            <rect x="2.5" y="11" width="1.5" height="1.5" rx="0.3" fill="#c2410c"/>
            <circle cx="3.25" cy="10.5" r="0.6" fill="#fb923c"/>
            {/* Rounded dome top */}
            <ellipse cx="3.25" cy="12.5" rx="3" ry="2" fill="#f97316" stroke="#1f2937" strokeWidth="0.4"/>
            <ellipse cx="3.25" cy="12.5" rx="2.5" ry="1.5" fill="#fb923c" opacity="0.5"/>
            {/* Main tank body */}
            <rect x="0.5" y="13" width="5.5" height="16" rx="2.5" fill="#f97316" stroke="#1f2937" strokeWidth="0.4"/>
            {/* Shine highlight */}
            <rect x="1.5" y="15" width="1" height="12" rx="0.5" fill="white" opacity="0.35"/>
            {/* Label band */}
            <rect x="0.5" y="20" width="5.5" height="3" fill="#c2410c" rx="0.3"/>
            <text x="3.25" y="22.5" fontSize="2" fill="white" textAnchor="middle" fontWeight="bold">404A</text>
            {/* Bottom base/stand */}
            <rect x="0.5" y="29" width="5.5" height="2" rx="1" fill="#c2410c"/>
            <ellipse cx="3.25" cy="31" rx="3.2" ry="1" fill="#ea580c"/>
          </g>
          
          {/* Ground shadow */}
          <ellipse cx="32" cy="43" rx="28" ry="2" fill="#000000" opacity="0.06"/>
        </svg>
      </div>
      
      {/* Brand Name with Professional Typography */}
      <div className="flex flex-col leading-tight">
        <div className="flex items-center gap-1.5">
          <span className="text-xl md:text-2xl lg:text-3xl font-extrabold text-blue-900 tracking-tight">
            HVAC
          </span>
          <span className="text-lg md:text-xl lg:text-2xl font-bold text-blue-600">
            Best
          </span>
        </div>
        <span className="text-[10px] md:text-xs font-semibold text-gray-600 tracking-widest uppercase mt-0.5">
          SUPPLY
        </span>
      </div>
    </div>
  );
};

export default Logo;
